import PropTypes from 'prop-types';
import React from 'react'; 
import { Link as RouterLink } from 'react-router-dom';
import cx from 'classnames';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';

import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { withContentNavigation } from './withContentNavigation';

import leftIcon from '@plone/volto/icons/left-key.svg';
import Image from '@plone/volto/components/theme/Image/Image';

import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';

const messages = defineMessages({
  navigation: {
    id: 'Secondary',
    defaultMessage: 'Secondary',
  },
});

function renderNode(node, parentLevel, currentPath) {
  const level = parentLevel + 1;
  const nodePath = flattenToAppURL(node['@id'] || node.href);
  const isCurrent = nodePath === currentPath;

  return (
    <li
      key={node['@id']} 
      className={`contextNavigation__item level-${level} ${isCurrent ? 'current' : ''}`}
    >
      {node.type !== 'link' ? (
        <RouterLink
          to={flattenToAppURL(node.href)} 
          className={cx(`contextNavigation__link contenttype-${node.type}`, {
            in_path: node.is_in_path,
          })}
        >
          {node.title}          
        </RouterLink>
      ) : (
        <UniversalLink href={flattenToAppURL(node.href)} className="contextNavigation__link">
          {node.title}
          <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
        </UniversalLink>
      )}
      {(node.items?.length && (
        <ul className='contextNavigation__subList list-unstyled'>
          {node.items.map((node) => renderNode(node, level, currentPath))}
        </ul>
      )) ||
        ''}
    </li>
  );
}

/**
 * A navigation slot implementation, similar to the classic Plone navigation
 * portlet. It uses the same API, so the options are similar to
 * INavigationPortlet
 */
export function ContextNavigationComponent(props) {
  const { navigation = {}, location } = props;
  const { items = [] } = navigation;
  const intl = useIntl();

  const currentPath = flattenToAppURL(location.pathname);

  return items.length ? (
    <>
      <BodyClass className="left-col" />
      <nav className="contextNavigation d-print-none" aria-label={intl.formatMessage(messages.navigation)}>      
        <ul className='contextNavigation__list list-unstyled'>
          {items.map((node) => renderNode(node, 0, currentPath))}
        </ul>
      </nav>
    </>
  ) : (
    ''
  );
}

ContextNavigationComponent.propTypes = {
  /**
   * Navigation tree returned from @contextnavigation restapi endpoint
   */
  navigation: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    has_custom_name: PropTypes.bool,
    title: PropTypes.string,
  }),
};

export default compose(
  withRouter,
  withContentNavigation,
)(ContextNavigationComponent);
